import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmerAnimation = keyframes`
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
`;

const ShimmerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: auto;
  height: 260px;
  background-color: #f6f7f8;
  position: relative;
  clip-path: polygon(
    0% 100%,
    10% 65%,
    20% 75%,
    30% 60%,
    40% 80%,
    50% 60%,
    60% 70%,
    70% 55%,
    80% 65%,
    90% 50%,
    100% 100%
  );
  background: linear-gradient(90deg, #f6f7f8 0px, #eaeaea 40px, #f6f7f8 80px);
  background-size: 200% 100%;
  animation: ${shimmerAnimation} 2.5s infinite linear;
`;

export const ChartDetailsShimmer: React.FC = () => <ShimmerWrapper />;
